import { ComponentProps, useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { api } from 'src/api/root'
import { STORAGE_KEYS } from 'src/enviroment/constants/storageKeys'
import useAuth from 'src/enviroment/hooks/useAuth'
import splitFullName from 'src/enviroment/utils/splitFullName'
import SingUpTemplate from 'src/templates/auth/sign-up/SignUpTemplate'
import { ROUTES } from 'src/types/routes'

export default function SignUpPage() {
  const navigate = useNavigate()
  const { isAuthenticated, logout } = useAuth()
  const [isInitializing, setIsInitializing] = useState<boolean>(true)

  const { mutateAsync, isLoading } = api.auth.signUp.useMutation()
  const invitationToken = new URLSearchParams(window.location.search).get('token')
  const invitedEmail = new URLSearchParams(window.location.search).get('email')

  const handleSubmit: ComponentProps<typeof SingUpTemplate>['onSubmit'] = async ({
    email,
    password,
    name,
    companyName,
    isRemember,
    marketingMailing,
  }) => {
    try {
      await mutateAsync({
        username: email,
        password,
        ...splitFullName(name),
        company: companyName,
        isRemember,
        invitationToken,
      })
      localStorage.setItem(STORAGE_KEYS.MARKETING_MAILING, marketingMailing.toString())

      navigate(`${ROUTES.ATLAS}?openCopa=true`)
    } catch (error) {
      console.error('Sign up failed:', error)
    }
  }

  useEffect(() => {
    const handleInitialCheck = async () => {
      // Log out only if user is authenticated AND has an invitation
      if (isAuthenticated && invitationToken && invitedEmail) {
        console.log(isAuthenticated, invitationToken, invitedEmail)
        console.log('User is authenticated but has an invitation. Logging out to allow sign up with the invited email.')
        await logout()
      }
      setIsInitializing(false)
    }

    handleInitialCheck()
  }, [isAuthenticated, invitationToken, invitedEmail, logout])

  if (isInitializing) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900" />
      </div>
    )
  }

  return <SingUpTemplate onSubmit={handleSubmit} isLoading={isLoading} invitedEmail={invitedEmail} />
}
